<template>
  <v-row>
    <v-col cols="12" class="ledger">
      <transaction-tabs type="imprest"></transaction-tabs>
      <v-card>
        <v-card-title class="secondary--text">{{ title }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="3">
              <account-select
                label="تنخواه دار"
                :items-type="accountUsage.IMPREST"
                v-model="ledger.account"
                :floatAccount1.sync="ledger.floatAccount1"
                :floatAccount2.sync="ledger.floatAccount2"
                :floatAccount3.sync="ledger.floatAccount3"
                :floatAccount4.sync="ledger.floatAccount4"
              />
            </v-col>
            <template>
              <v-col cols="12" md="2">
                <date label="از تاریخ" v-model="filters.sanad__date__gte" clearable />
              </v-col>
              <v-col cols="12" md="2">
                <date label="تا تاریخ" v-model="filters.sanad__date__lte" clearable />
              </v-col>
              <v-col cols="12">
                <sanad-item-list-report colspan="3"
                  v-if="filters.account"
                  :filters.sync="filters"
                  :headers="headers"
                  :sortable="false"
                  :filterable="false"
                  :show-sum="true"
                  :showRemain="true"
                  :showPreviousRemain="true"
                  :showLink="true"
                />
              </v-col>
            </template>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import SanadItemListReport from "@/components/mcomponents/report/SanadItemListReport";
import queryBinding from "@/components/m-query-binding";
import AccountMixin from "@/mixin/accountMixin";
import TransactionTabs from "@/views/panel/transaction/TransactionTabs";

export default {
  name: "Ledger",
  mixins: [queryBinding, AccountMixin],
  components: { SanadItemListReport, TransactionTabs },
  props: {},
  data() {
    return {
      ledger: {
        account: null,
        floatAccount1: null,
        floatAccount2: null,
        floatAccount3: null,
        floatAccount4: null,
      },
      filters: {},
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle('گردش حساب تنخواه دار');
    },
    headers() {
      let headers = [
        {
          text: "تاریخ",
          value: "sanad.date",
          type: "date",
          sortable: this.sortable,
          filterable: this.filterable,
        },
        // {
        //   text: "شماره سند",
        //   value: "sanad.code",
        //   sortable: this.sortable,
        //   filterable: this.filterable,
        //   showRangeFilter: true,
        // },
        {
          text: "شرح",
          value: "explanation",
          sortable: this.sortable,
          filterable: this.filterable,
        },
        {
          text: "مبلغ شارژ تنخواه",
          value: "bed",
          type: "numeric",
          sortable: this.sortable,
          filterable: this.filterable,
        },
        {
          text: "مبلغ تسویه تنخواه",
          value: "bes",
          type: "numeric",
          sortable: this.sortable,
          filterable: this.filterable,
        },
        {
          text: "مانده",
          value: "remain",
          type: "numeric",
          sortable: false,
          filterable: false,
          align: "center",
          show: this.showRemain,
        },
        {
          text: "تشخیص",
          value: "remain_type",
          sortable: false,
          filterable: false,
          align: "center",
          show: this.showRemain,
        },
        {
          text: "جزئیات",
          value: "sanad_form",
          sortable: false,
          filterable: false,
          hideInExport: true,
          align: "center",
        },
        {
          text: "مشاهده سند",
          value: "detail",
          sortable: false,
          filterable: false,
          align: "left",
          hideInExport: true,
          show: this.showLink,
        },
      ];
      return headers;
    },
  },
  created() {
    this.filters = this.getFiltersTemplate();
  },
  watch: {
    ledger: {
      deep: true,
      handler() {
        Object.keys(this.ledger).forEach((key) => {
          if (this.ledger[key]) {
            this.$set(this.filters, key, this.ledger[key].id);
          }
        });
      },
    },
  },
  methods: {
    getFiltersTemplate() {
      return {
        financial_year: this.financialYear.id,
        order_sanads_by: "code",
        title: this.title,
        consider_previous_remain: "true",
        report_type: "imprest",
      };
    },
  },
};
</script>

<style scoped lang="scss"></style>
